import { useCallback, useState } from 'react';

import { useIntersect } from '@common/hooks';
import { Log } from '@common/log-manager';

interface Props {
  type: 'store' | 'category' | 'zigzin-shipping';
  params: { shop_id: string; category_id?: string | null };
  has_next_page?: boolean;
  onFetchNextPage: () => void;
}

export const useComponentListService = ({ type, params, has_next_page, onFetchNextPage }: Props) => {
  const [columnCount, setColumnCount] = useState<2 | 3>(2);

  const pageLog: Partial<Log> | undefined =
    type === 'zigzin-shipping'
      ? undefined
      : {
          navigation: type === 'store' ? 'shop_detail' : 'shop_category_detail',
          navigation_sub: { shop_id: params.shop_id },
          data: type === 'store' ? undefined : { category_id: params.category_id },
        };

  const intersectionObserverCallback = useCallback(
    (entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting && has_next_page) {
        onFetchNextPage();
      }
    },
    [has_next_page, onFetchNextPage],
  );

  const { targetRef } = useIntersect(intersectionObserverCallback);

  return {
    pageLog,
    targetRef,
    columnCount,
    setColumnCount,
  };
};
